import { useAppSelector } from "../../hooks/StoreHooks";

export const useGroupsData = () =>
  useAppSelector((state) => state.groups.groupsData);

export const useOnGroupsSave = () =>
  useAppSelector((state) => state.groups.onSave);
